import { useMemo } from 'react';
import { ProjectData } from '@/types/project';
import { calculateMetrics } from '@/utils/calculations';

export function useMemoizedCalculations(data: ProjectData) {
  return useMemo(() => calculateMetrics(data), [
    data.value.contractValue,
    data.value.approvedVariations,
    data.value.unapprovedVariations,
    data.costs.labour,
    data.costs.materials,
    data.costs.plant,
    data.costs.subcontractor,
    data.costs.overheads,
  ]);
}